"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visuallyHidden = void 0;
const visuallyHidden = exports.visuallyHidden = {
  clip: 'rect(0 0 0 0)',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  position: 'fixed',
  top: 0,
  left: 0,
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
};